import { useState } from 'react';

import { Button, DatePicker, TextField } from '@atom/mui';

import classes from '../../styles/left-pane.module.css';

interface FilterState {
  createdOnDateStart?: number | object;
  createdOnDateEnd?: number | object;
  createdBy?: string;
  workTemplateIds?: string[];
}

const WorkExportsFilter = () => {
  const [filters, setFilters] = useState<FilterState>({});

  const resetFilters = () => {};

  const applyFilters = () => {};

  const updateCreatedOnDateFilter = () => {
    setFilters({
      ...filters,
    });
  };

  const isFilterDisplayed = false;

  return (
    <div className={classes.leftPane}>
      {isFilterDisplayed && (
        <>
          <div className={classes.filtersHeader}>
            <div className={classes.filtersHeaderLabel}>Filter</div>
            <Button onClick={resetFilters}>Reset</Button>
            <Button disabled={false} onClick={() => applyFilters()}>
              Apply
            </Button>
          </div>
          <div className={classes.dateRangeTitle}>Created on</div>
          <div className={classes.dateRangeContainer}>
            <DatePicker
              name="createdOnDateStart"
              value={new Date(Number(filters?.createdOnDateStart))}
              onChange={updateCreatedOnDateFilter}
              disabled={false}
            />
            <span
              style={{ alignSelf: 'center', padding: '0 1.25rem 0 1.25rem' }}
            >
              to
            </span>
            <DatePicker
              name="createdOnDateEnd"
              value={new Date(Number(filters?.createdOnDateEnd))}
              onChange={updateCreatedOnDateFilter}
              disabled={false}
            />
          </div>

          <div className={classes.selectFilterWrapper}>
            <TextField label="Created by" placeholder="Search by name" />
          </div>
        </>
      )}
    </div>
  );
};

export default WorkExportsFilter;
